export const LABEL_FORMATS = [
  { key: '40x50', name: '40×50 mm', width_mm: 40, height_mm: 50 },
  { key: '50x30', name: '50×30 mm', width_mm: 50, height_mm: 30 },
  { key: '60x40', name: '60×40 mm', width_mm: 60, height_mm: 40 },
  { key: '70x50', name: '70×50 mm', width_mm: 70, height_mm: 50 },
  { key: '100x100', name: '100×100 mm', width_mm: 100, height_mm: 100 },
  { key: '100x150', name: '100×150 mm', width_mm: 100, height_mm: 150 },
];
